module.exports = __webpack_public_path__ + "e0946af44dd42410a8ba6ed72db0a34a.svg";